import { render, staticRenderFns } from "./SiteLogo.vue?vue&type=template&id=c6dca80c&scoped=true&"
import script from "./SiteLogo.vue?vue&type=script&lang=ts&"
export * from "./SiteLogo.vue?vue&type=script&lang=ts&"
import style0 from "./SiteLogo.vue?vue&type=style&index=0&id=c6dca80c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dca80c",
  null
  
)

export default component.exports